import type { ReactNode } from 'react';

/** Consistent page padding for the mobile column. */
export function Screen({ children }: { children: ReactNode }) {
  return <div style={{ padding: '36px 20px 24px' }}>{children}</div>;
}
